/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetCustomActionPlansQuery } from "~/generated/graphql";
import { isNotNil } from "~/tools";

type Props = {
  customActionId: string;
};

export function useGetCustomActionPlans({ customActionId }: Props) {
  const { data, loading, error } = useGetCustomActionPlansQuery();
  const count = data?.plans.pageInfo?.count ?? 0;

  // TODO: Plans should be filtered at core api level
  const customActionPlans = () => {
    return data?.plans.result
      ?.flatMap(({ planActions, name }) => {
        return planActions?.map(({ action }) => {
          if (action.__typename === "Action" && action.id === customActionId) {
            return name;
          }
        });
      })
      .filter(isNotNil);
  };

  const planNames = count > 0 ? customActionPlans() : [];

  return { planNames: planNames ?? [], loading, error, count } as const;
}
